import { LoadWrapper, PageLayout, UnauthorizedMessage } from '@anyx/shared-ui';

export const ErrorUnauthorizedPage = () => {
  return (
    <PageLayout withNavigation={false} fullPage={true} loadingComponent={<LoadWrapper />}>
      <UnauthorizedMessage />
    </PageLayout>
  );
};
